import { Grid, Box, Stack } from '@mui/material';
import { useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { ControlledTextInput, WsButton } from 'wisestep-base';

import FAQDetailsDetailsCommonFields from '../FAQDetailsCommonFields';
import FAQDetailsPage from '../FAQDetailsPage';

const Candidates = () => {
  const methods = useForm();
  const candidates = [
    {
      title: 'Q: What is a Candidates mapping and how does it help ?',
      text: 'A: The Candidate mapping page helps you organize your work better and record your conversations with Candidates to help understand their preferences leading to better engagement an overall better experience.',
      optionalText:
        'When you click on Add Candidate button on a Job record, you open the Mapping page for that Job. Candidate Mappings are also called Tearsheets.This is a list of Candidates who you consider speaking or contacting and making notes of their Preferences.Since there are many interactions between a Recruiter and a Candidate this page helps you keep track Conversations with Each Candidate',
    },
    {
      title: 'Q: Do I need to enter all the fields on the Candidate Mapping page ?',
      text: 'A: The short answer is No. You should enter as much information as you have or can get   in your conversations with the Candidates.',
      optionalText: '',
    },
    {
      title: 'Q: How can I Submit a Candidate to a Job ?',
      text: ' A: Use the Submit Candidate button to Submit Candidates from the Candidate Mapping sheet directly.If you want to submit a Candidate that is mapped, just click on“ Save and Start Submission” and it will take you to the“ Submit Candidate” Page ',
      optionalText:
        'Email address are retained so that if someone adds the Candidate again by mistake, they are reminded that the Candidate is on the delete list.',
    },
    {
      title: 'Q: How can I edit an already Submitted Candidate ?',
      text: 'A: On the submitted Candidate page for every Candidate record, you will find an edit button at the bottom of the record.Click on that to open the edit mode and update any information that you need to. Save to Submit the Candidate again.',
      optionalText: '',
    },
    {
      title: 'Q: Is there an easier way to add Candidate Data to the Candidate Mapping page ?',
      text: 'A: Yes, there is.Use our Chrome Browser Extension to instantly capture Data from Job boards and social networks like LinkedIn.This will prefill all the Candidate preferences in your Candidate mapping sheet.Get the Extension here',
      optionalText: '',
    },
    {
      title: 'Q: How do I send the Candidate Submission from Wisestep to my Email ?',
      text: 'A: On Submitted Candidates page, Use the Email button on the top right - hand corner to open a popup and send the submitted Candidate details to your self or to anyone else.',
      optionalText: '',
    },
    {
      title: 'Q: I am getting all the notifications and email from Recruiter@wisestepmail.com ?',
      text: 'A: The notifications sent by the Wisestep platform to you are sent from a Wisestep email domain.',
      optionalText: '',
    },
    {
      title: 'Q: Can I connect my email to my Wisestep account ?',
      text: 'A: We hope to offer this feature to you soon.',
      optionalText: '',
    },
    {
      title: 'Q: How do I Search My Submitted Candidates and Mapped Candidates ?',
      text: 'A: All your Mapped and Submitted Candidates are available under the Search Candidates page under the Candidates tab on the Menu.Use the Advanced search to find and map Candidates to Jobs',
      optionalText: '',
    },
    {
      title: 'Q: How do I update Candidate contact information ?',
      text: 'A: On Any Candidate Record in the Search Candidates Page click on More to open the right-hand panel to see the details of All the Conversations and Jobs Associated with a specific Candidate.You can update Candidate details from the Update button under the Candidate information box.',
      optionalText: '',
    },
  ];
  const [candidateList, setCandidateList] = useState<
    { title: string; text: string; optionalText: string }[] | undefined
  >(candidates);

  const [textValue, setTextValue] = useState('');

  const handleOnClick = () => {
    const findText =
      candidates && candidates?.length > 0
        ? candidates?.filter((b) => b?.title.toUpperCase().includes(textValue.toUpperCase()))
        : undefined;
    setCandidateList(findText);
  };
  return (
    <FAQDetailsPage>
      <Box pt={2}>
        <FormProvider {...methods}>
          <Grid item xs={12} pb={2} bgcolor="white" p={2}>
            <Stack direction="row" spacing={1}>
              <ControlledTextInput
                placeholder="Search..."
                name="search"
                type="text"
                fullWidth
                required
                autoComplete="text"
                value={textValue}
                onChange={(e) => setTextValue(e.target.value)}
              />
              <WsButton disabled={!textValue} size="large" onClick={handleOnClick}>
                Search
              </WsButton>
            </Stack>
          </Grid>
          <Grid container spacing={2} pt={2}>
            {candidateList &&
              candidateList?.length > 0 &&
              candidateList?.map((list, index) => (
                <Grid item xs={12} key={index}>
                  <FAQDetailsDetailsCommonFields
                    title={list.title}
                    text={list.text}
                    optionalText={list.optionalText}
                  />
                </Grid>
              ))}
          </Grid>
        </FormProvider>
      </Box>
    </FAQDetailsPage>
  );
};
export default Candidates;
